import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const Cancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center py-12 px-4" data-testid="payment-cancel-page">
      <div className="max-w-md w-full glass-panel rounded-2xl p-8 text-center border">
        <XCircle className="w-16 h-16 mx-auto mb-4" style={{ color: '#ef4444' }} />
        <h1 className="text-2xl font-bold mb-2" style={{ color: '#ffffff' }} data-testid="payment-cancelled">
          Payment Cancelled
        </h1>
        <p className="text-muted-foreground mb-6">
          Your payment was cancelled. No charges were made to your account.
        </p>
        <div className="space-y-3">
          <Button
            onClick={() => navigate('/pricing')}
            className="w-full rounded-full"
            style={{ background: '#D4AF37', color: '#141414', fontWeight: '600' }}
            data-testid="back-to-pricing-button"
          >
            Back to Pricing
          </Button>
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="w-full rounded-full"
          >
            Go to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Cancel;
